import React from 'react';

import { Heading, PropertyGroup } from '../../../../components';

import css from '../../../../containers/ListingPage/ListingPage.module.css';

const createFilterOptions = options => options.map(o => ({ key: `${o.option}`, label: o.label }));

const PlaceTypeWithIcons = ({ listing, listingConfig }) => {
  const featuresSelectedValues = listing.attributes.publicData.placetype;
  const fieldConfig = listingConfig.listingFields.find(c => c.key === 'placetype');

  if (!featuresSelectedValues || !fieldConfig) return null;

  const { enumOptions, showConfig } = fieldConfig;

  return (
    <div className={css.sectionMultiEnum}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {showConfig.label}
      </Heading>
      <PropertyGroup
        id="placetype"
        options={createFilterOptions(enumOptions)}
        selectedOptions={featuresSelectedValues}
        twoColumns={enumOptions.length > 5}
      />
    </div>
  );
};

export default PlaceTypeWithIcons;
